import { render, staticRenderFns } from "./IschemicHeartDisease.vue?vue&type=template&id=f432ec50&scoped=true"
import script from "./IschemicHeartDisease.vue?vue&type=script&lang=js"
export * from "./IschemicHeartDisease.vue?vue&type=script&lang=js"
import style0 from "./IschemicHeartDisease.vue?vue&type=style&index=0&id=f432ec50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432ec50",
  null
  
)

export default component.exports